import { render } from "./FormaPago_Pago.vue?vue&type=template&id=74b9b2af"
import script from "./FormaPago_Pago.vue?vue&type=script&lang=js"
export * from "./FormaPago_Pago.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__